import React from 'react';
import PropTypes from 'prop-types';
import BaseActionHandler from './BaseActionHandler';
import { ServiceDialog } from '../../../../common/components/Layout/StandardPageTemplate/Context';

export const isServerError = status => {
  if (status >= 500 && status < 600) {
    return true;
  }
  return false;
};

export default class ActionHandler extends React.Component {
  static propTypes = {
    action: PropTypes.func,
    data: PropTypes.array,
    condition: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    forceUpdate: PropTypes.bool,
    children: PropTypes.func,
  };

  render() {
    const { children, ...rest } = this.props;
    return (
      <BaseActionHandler {...rest}>
        {result => {
          if (
            result &&
            result.hasError &&
            result.status &&
            isServerError(result.status)
          ) {
            return <ServiceDialog />;
          } else if (typeof children === 'function') {
            return children(result);
          } else {
            return null;
          }
        }}
      </BaseActionHandler>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/account/components/ActionHandler/index.js